import { index } from "../../api/endpoints/driver_payments";

export const state = {
  total: 1,
  data: []
}

export const getters = {
  items(state) {
    return state.data
  },
  total(state) {
    return state.total
  }
}

export const mutations = {
  FETCH_DATA(state, payload) {
    // eslint-disable-next-line no-console
    console.log(payload);
  }
}

export const actions = {
  fetchData({commit}, params) {
    return new Promise( (resolve, reject) => {
      index(params).then( res => {
        commit('FETCH_DATA', res.data);
        resolve(res)
      }).catch( err => {
        reject(err)
      })
    })
  }
}